var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from 'react';
import { WidgetType } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import Modal from '@shared/modal/Modal';
import Manager from '@shared/modal/Manager';
import { CheckBox } from '@shared/input/CheckBox';
import ModalHeader from '@shared/modal/ModalHeader';
import ModalFooter from '@shared/modal/ModalFooter';
import TextInput from '@shared/input/TextInput';
import SelectInput from '@shared/input/SelectInput';
import ClusterParentSelect from '@shared/input/ClusterParentSelect';
import { TagNameDisplay } from '@data/types';
import { useTagContext } from '@data/tag/tagContext';
import { shownInKpis } from '@data/exportConfiguration/exportConfiguration';
import { useExportConfigurations } from '@data/exportConfiguration/exportConfigurationActions';
import { parseWidgetConfig } from '@data/widgets/widgetConfig';
import { useCreateWidget, useGetKPIColumnsFromSlicer, useUpdateWidget, useWidgets } from '@data/widgets/widgetActions';
import { NumberFormatType, numberFormatTypesMeta } from '@util/enums';
import { ModalBody } from '@styled/Modal';
import { FormField, FormFieldErrorHelp, FormFieldLabel } from '@styled/Form';
import { FlexRow } from '@styled/FlexWrappers';
import RadioInput from '@shared/input/RadioInput';
import { getSheetRowParents, SheetRowPath } from '../../../data/sheetRow/sheetRow';
import { useSheetRowsById } from '../../../data/sheetRow/sheetRowHooks';
function KPIEditor(props) {
    return (React.createElement(Modal, { width: 600 },
        React.createElement(KPIEditorForm, __assign({}, props))));
}
var KPIEditorForm = function (props) {
    var _a, _b, _c, _d;
    var L = useLanguage().L;
    var exportConfigurations = useExportConfigurations();
    var tagData = useTagContext().tagData;
    var getKPIColumnsFromSlicer = useGetKPIColumnsFromSlicer();
    var widgets = (_a = useWidgets().data) !== null && _a !== void 0 ? _a : [];
    var createWidget = useCreateWidget();
    var updateWidget = useUpdateWidget();
    var sheetRowsById = useSheetRowsById();
    var defaultKpi = (_c = (_b = exportConfigurations === null || exportConfigurations === void 0 ? void 0 : exportConfigurations.data) === null || _b === void 0 ? void 0 : _b.filter(shownInKpis)) === null || _c === void 0 ? void 0 : _c[0];
    var _e = __read(useState(props.widget
        ? props.widget
        : {
            title: '',
            type: WidgetType.KPI,
            config: JSON.stringify(__assign(__assign({}, parseWidgetConfig(null, WidgetType.KPI)), { exportConfigurationId: defaultKpi === null || defaultKpi === void 0 ? void 0 : defaultKpi.id })),
            GridId: props.gridId,
        }), 2), widgetState = _e[0], setWidgetState = _e[1];
    var _f = __read(useState({}), 2), invalid = _f[0], setInvalid = _f[1];
    useEffect(function () {
        !props.widget &&
            setWidgetState(__assign(__assign({}, widgetState), { config: JSON.stringify(__assign(__assign({}, parseWidgetConfig(null, WidgetType.KPI)), { exportConfigurationId: defaultKpi === null || defaultKpi === void 0 ? void 0 : defaultKpi.id })) }));
    }, [props.widget, defaultKpi === null || defaultKpi === void 0 ? void 0 : defaultKpi.id]);
    function validate(payload, payloadConfig) {
        var invalid = {};
        if (!payloadConfig.path) {
            invalid.parent = L('You must select a row');
        }
        return invalid;
    }
    var widgetConfig = useMemo(function () { return parseWidgetConfig(widgetState.config, WidgetType.KPI); }, [widgetState.config]);
    function done() {
        return __awaiter(this, void 0, void 0, function () {
            var widgetCopy, widgetConfigCopy, kpiCols, _invalid, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        widgetCopy = __assign({}, widgetState);
                        widgetConfigCopy = __assign({}, widgetConfig);
                        if (widgetConfigCopy.useSlicerData) {
                            kpiCols = getKPIColumnsFromSlicer(props.gridId, tagData.internalTagsMap);
                            widgetConfigCopy.kpiCols = kpiCols;
                        }
                        _invalid = validate(widgetCopy, widgetConfigCopy);
                        if (!(Object.keys(_invalid).length > 0)) return [3 /*break*/, 1];
                        setInvalid(_invalid);
                        return [3 /*break*/, 6];
                    case 1:
                        widgetCopy.config = JSON.stringify(widgetConfigCopy);
                        if (!('id' in widgetCopy)) return [3 /*break*/, 3];
                        return [4 /*yield*/, updateWidget.mutateAsync(widgetCopy)];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, createWidget.mutateAsync(widgetCopy)];
                    case 4:
                        _a = _b.sent();
                        _b.label = 5;
                    case 5:
                        _a;
                        Manager.closeModal();
                        _b.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    function updateTitle(newTitle) {
        var widgetCopy = __assign({}, widgetState);
        widgetCopy.title = newTitle;
        setWidgetState(widgetCopy);
    }
    function updateWidgetConfig(field, value) {
        var widgetCopy = __assign({}, widgetState);
        var widgetConfigCopy = __assign({}, widgetConfig);
        widgetConfigCopy[field] = value;
        widgetCopy.config = JSON.stringify(widgetConfigCopy);
        setWidgetState(widgetCopy);
    }
    var kpiWidgetIds = __spreadArray([
        { label: L('None'), value: null }
    ], __read(widgets
        .filter(function (w) { return w.type === WidgetType.KPI && ('id' in widgetState ? w.id !== widgetState.id : true); })
        .sort(function (a, b) { return (a.GridId === b.GridId ? a.id - b.id : a.GridId - b.GridId); })
        .map(function (w) { return ({
        label: w.title,
        value: w.id,
    }); })), false);
    var title = props.widget ? "".concat(L('Editing KPI'), " \"").concat(props.widget.title, "\"") : L('Create New KPI');
    var sheetPath = new SheetRowPath(widgetConfig.path);
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { title: title }),
        React.createElement(ModalBody, null,
            React.createElement("form", null,
                React.createElement(TextInput, { label: L('Title'), value: widgetState.title, name: "title", onChange: function (e) { return updateTitle(e.target.value); }, bottomMargin: true }),
                React.createElement(FormField, { "$bottomSpace": true },
                    React.createElement(FormFieldLabel, null, L('Row')),
                    React.createElement(ClusterParentSelect, { placeholder: L('Select Row'), selected: sheetPath.sheetRowId, location: "ClusterId", onChange: function (sheetRowId) {
                            var sheetRow = sheetRowsById[sheetRowId];
                            if (!sheetRow) {
                                return;
                            }
                            var parents = getSheetRowParents(sheetRow, sheetRowsById);
                            var path = parents
                                .reverse()
                                .map(function (p) { return (p === null ? '0' : "".concat(p.id)); })
                                .join('_');
                            path += '_' + sheetRow.id;
                            updateWidgetConfig('path', path);
                        } }),
                    invalid.parent && React.createElement(FormFieldErrorHelp, null, invalid.parent)),
                React.createElement(FormField, { "$bottomSpace": true },
                    React.createElement(FormFieldLabel, null, L('Row name display')),
                    React.createElement(FlexRow, null,
                        React.createElement(RadioInput, { action: function () { return updateWidgetConfig('rowNameDisplay', TagNameDisplay.Name); }, checked: widgetConfig.rowNameDisplay === TagNameDisplay.Name, category: 'rowNameDisplay', label: L('Name') }),
                        React.createElement(RadioInput, { action: function () { return updateWidgetConfig('rowNameDisplay', TagNameDisplay.Description); }, checked: widgetConfig.rowNameDisplay === TagNameDisplay.Description, category: 'rowNameDisplay', label: L('Description') }),
                        React.createElement(RadioInput, { action: function () { return updateWidgetConfig('rowNameDisplay', TagNameDisplay.Both); }, checked: widgetConfig.rowNameDisplay === TagNameDisplay.Both, category: 'rowNameDisplay', label: L('Both') }))),
                React.createElement(SelectInput, { name: "numformat", value: (_d = widgetConfig.numformat) !== null && _d !== void 0 ? _d : NumberFormatType.TWO_DECIMALS, label: L('Format'), onChange: function (e) {
                        if (!e.target.value) {
                            return;
                        }
                        updateWidgetConfig('numformat', e.target.value);
                    }, options: Object.entries(NumberFormatType).map(function (_a) {
                        var _b = __read(_a, 2), key = _b[0], value = _b[1];
                        return ({
                            label: L(numberFormatTypesMeta[value].label),
                            value: value,
                        });
                    }), bottomMargin: true }),
                React.createElement(SelectInput, { name: "sharedColumnConfigWidgetId", value: widgetConfig.sharedColumnConfigWidgetId, label: L('Shared Column Config Preset'), onChange: function (e) {
                        return updateWidgetConfig('sharedColumnConfigWidgetId', e.target.value !== null ? Number(e.target.value) : e.target.value);
                    }, disabled: !(kpiWidgetIds === null || kpiWidgetIds === void 0 ? void 0 : kpiWidgetIds.length), options: kpiWidgetIds, bottomMargin: true }),
                React.createElement(FormField, null,
                    React.createElement(CheckBox, { action: function () { return updateWidgetConfig('showZeroSumRows', !widgetConfig.showZeroSumRows); }, checked: widgetConfig.showZeroSumRows, label: L('Show Zero Sum Rows') })),
                widgetConfig.sharedColumnConfigWidgetId === null && (React.createElement(FormField, null,
                    React.createElement(CheckBox, { action: function () { return updateWidgetConfig('useSlicerData', !widgetConfig.useSlicerData); }, checked: widgetConfig.useSlicerData, label: L('Use Data from Timeline Slicer') }))),
                React.createElement(FormField, null,
                    React.createElement(CheckBox, { action: function () { return updateWidgetConfig('useTagSlicers', !widgetConfig.useTagSlicers); }, checked: widgetConfig.useTagSlicers, label: L('Use Data from Dimension Slicer') })))),
        React.createElement(ModalFooter, { done: done })));
};
export default KPIEditor;
